"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const theme_provider_1 = require("../../theme-provider");
const example_theme_definitions_1 = require("../../theme-provider/example-theme-definitions");
const StyledDemoToggleLabel = theme_provider_1.styled.label.withConfig({ displayName: "StyledDemoToggleLabel", componentId: "sc-5zbrbm" }) `
	position: fixed;
	right: 0;
	bottom: 0;
	cursor: pointer;
	opacity: 0.3;
	background: #fff;
	transition: opacity ease-in-out 0.25s;
	font: 400 11px system-ui;
	margin-bottom: 10px;

	&:hover {
		opacity: 1;
	}
`;
const StyledDemoThemeToggle = theme_provider_1.styled.select.withConfig({ displayName: "StyledDemoThemeToggle", componentId: "sc-1n253gd" }) `
	border: 1px dashed #8f8f8f;
	border-radius: 4px;
	padding: 6px 8px 8px 8px;
	margin-bottom: 20px;
	cursor: pointer;
`;
exports.DemoThemeProviderToggleContext = React.createContext({
    hasImageTheme: false,
    direction: 'ltr',
    language: ''
});
// @todo @refactor this is a temporary solution
//  rework this and use a standalone toggle component with
//  special DemoThemeContext.Provider/Consumer
class DemoThemeProviderWithToggle extends React.Component {
    constructor(props) {
        super(props);
        this.handleThemeChange = (e) => {
            const theme = e.target.value;
            this.setState(state => (Object.assign(Object.assign({}, state), { theme })));
        };
        this.handleDirectionChange = (e) => {
            const direction = e.target.value;
            this.setState(state => (Object.assign(Object.assign({}, state), { direction })));
        };
        this.handleLanguageChange = (e) => {
            const language = e.target.value;
            this.setState(state => (Object.assign(Object.assign({}, state), { language })));
        };
        this.state = {
            theme: 'main',
            direction: 'ltr',
            language: ''
        };
    }
    render() {
        const { children } = this.props;
        const { theme, direction, language } = this.state;
        const hasImageTheme = theme === 'image';
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledDemoToggleLabel, null,
                "Use Theme:\u00A0",
                React.createElement(StyledDemoThemeToggle, { onChange: this.handleThemeChange }, Object.keys(example_theme_definitions_1.themeSet).map(key => (React.createElement("option", { value: key, key: key }, key)))),
                "\u00A0 Direction:\u00A0",
                React.createElement(StyledDemoThemeToggle, { onChange: this.handleDirectionChange },
                    React.createElement("option", { value: "ltr", key: "ltr" }, "LTR"),
                    React.createElement("option", { value: "rtl", key: "rtl" }, "RTL")),
                "\u00A0 Language:\u00A0",
                React.createElement(StyledDemoThemeToggle, { onChange: this.handleLanguageChange },
                    React.createElement("option", { value: "", key: "default" }, "Default"),
                    React.createElement("option", { value: "ko", key: "ko" }, "Korean"),
                    React.createElement("option", { value: "zh", key: "zh" }, "Chinese (Simplified | China)"),
                    React.createElement("option", { value: "tw", key: "tw" }, "Chinese (Traditional | Taiwan)"),
                    React.createElement("option", { value: "ja", key: "ja" }, "Japanese"),
                    React.createElement("option", { value: "ar", key: "ar" }, "Arabic"))),
            React.createElement(theme_provider_1.ThemeProvider, { theme: this.state.theme },
                React.createElement(exports.DemoThemeProviderToggleContext.Provider, { value: { hasImageTheme, direction, language } }, children))));
    }
}
exports.DemoThemeProviderWithToggle = DemoThemeProviderWithToggle;
